const alexandriaListeners = new Set()
function handleScroll() {
  const docHeight = document.body.clientHeight
  const scrollPos = window.scrollY
  const windowHeight = window.innerHeight
  const progress = scrollPos / (docHeight - windowHeight)
  Array.from(alexandriaListeners).forEach((listener) =>
    listener({
      docHeight,
      windowHeight,
      scrollPos,
      progress,
    })
  )
}

window.addEventListener("scroll", handleScroll, { passive: true })
window.addEventListener("DOMContentLoaded", handleScroll)

function addScrollListener(func) {
  alexandriaListeners.add(func)
  setTimeout(handleScroll, 50)
}

function removeScrollListener(func) {
  alexandriaListeners.delete(func)
}
